import { createSlice } from "@reduxjs/toolkit";
import { BadgeSyncStatus, PAPER_SIZE } from "../../../common/enums";
import { RootState } from "../../types";
import dayjs from "../../../common/dayjs";

const initialState: RootState["metadata"] = {
  isAdmin: false,
  lastBadgeUpdateTime: dayjs(new Date()).format(),
  badgePrintFormat: PAPER_SIZE.FOUR_X_TEN_INCH,
  offline: false,
  badgeSyncStatus: BadgeSyncStatus.DOWNLOADING,
  activeBadgeSyncRequests: 0
};

const metadataSlice = createSlice({
  name: "metadata",
  initialState,
  reducers: {
    setBadgePrintFormat: (state, action) => {
      state.badgePrintFormat = action.payload;
    },
    setLastBadgeUpdateTime: (state, action) => {
      state.lastBadgeUpdateTime = action.payload;
    },
    setOffline: (state, action) => {
      state.offline = action.payload;
    },
    setIsAdmin: (state, action) => {
      state.isAdmin = action.payload;
    },

    badgeSyncRequestStarted: state => {
      state.activeBadgeSyncRequests = (state.activeBadgeSyncRequests ?? 0) + 1;
      state.badgeSyncStatus = BadgeSyncStatus.DOWNLOADING;
    },
    badgeSyncRequestCompleted: state => {
      const current = state.activeBadgeSyncRequests ?? 0;
      state.activeBadgeSyncRequests = current > 0 ? current - 1 : 0;

      if (
        state.activeBadgeSyncRequests === 0 &&
        state.badgeSyncStatus !== BadgeSyncStatus.DOWNLOAD_FAILED &&
        state.badgeSyncStatus !== BadgeSyncStatus.SYNCING_FAILED
      ) {
        state.badgeSyncStatus = BadgeSyncStatus.SUCCESS;
      }
    },
    badgeSyncRequestFailed: state => {
      const current = state.activeBadgeSyncRequests ?? 0;
      state.activeBadgeSyncRequests = current > 0 ? current - 1 : 0;
      state.badgeSyncStatus = BadgeSyncStatus.DOWNLOAD_FAILED;
    },
    badgeSyncSyncFailed: state => {
      state.activeBadgeSyncRequests = 0;
      state.badgeSyncStatus = BadgeSyncStatus.SYNCING_FAILED;
    }
  }
});

export const {
  setBadgePrintFormat,
  setLastBadgeUpdateTime,
  setOffline,
  setIsAdmin,
  badgeSyncRequestStarted,
  badgeSyncRequestCompleted,
  badgeSyncRequestFailed,
  badgeSyncSyncFailed
} = metadataSlice.actions;

export default metadataSlice.reducer;
